<template lang="pug">
.case-container
    .case-content
      .case-case__title
          div(
            style="width:4px;height:80px;background-color: #478bca;"
          )
          .title__content
            span {{ $t('案例分享：享网互动') }}
            span {{ $t('享网互动，一位驰骋互联网的“数字骇客”。立足于中国数字媒体环境，开拓最新营销潮流，服务可口可乐、哈尔滨啤酒等200多个知名企业！') }}
      .case-case__summary
        div(
          style="margin-right: 300px"
        )
          i.iconfont.iconhangye
          span {{ $t('广告主行业：广告') }}

        div
          i.iconfont.iconbumen
          span {{ $t('涉及部门：财务、市场') }}
      .case-case__content__item
          .content__title {{ $t('案例简介：') }}
          .content {{ $t('帮助享网互动解决了公对私付款时费用高、不合规的难题。   ') }}

      .case-case__content__item
          .content__title {{ $t('客户当前痛点：') }}
          .content 1）{{ $t('直接支付个人账户或通过走账公司会产生高额成本，增加财税负担。') }}
          .content 2）{{ $t('付款到个人账户，个人需去税务局申请发票，因流程繁琐多数个人不愿意去申请，导致没有对应发票，最终导致业务流、资金流、票据流、合同流四流不合一。')}}
          .content 3）{{ $t('付款至个人账户，结算笔数多且财务流程处理消耗大量人力，导致效率很低。') }}
      .case-case__content__item
          .content__title {{ $t('复歌解决方案：') }}
          .content {{ $t('我们为客户提供了轻轻付解决方案，并提供平台让客户直接操作：首先在平台把二维码给到个人签约，签约成功后客户进行发包、派单、打款到复歌账户，复歌收到款项后，会在1小时内审核并发放至个人签约帐户，之后会在每个月的15-20号给到客户完税证明。') }}
      .case-case__content__item
          .content__title {{ $t('最终结果：') }}
          .content {{ $t('首先客户通过复歌平台付款到待收款个人账户，税源地通过正规渠道为个人缴纳税费并提供完税证明，让付款合法合规。其次，客户对复歌公对公结算，可获取增值税专用发票并且可以抵扣。截止2020年5月31号，客户通过使用复歌轻轻付平台操作，节省了近10%的成本。') }}
    contact
</template>"

<script>
import Contact from '@/components/Contact'
export default {
  components: {
    Contact
  }
}
</script>
